import config from '@/config/index';
import { loading } from '../../common/loading';
import { getUserInfoAjax2, getCaseCountNew, lisFunctionVOTreeMobile } from '@/api/baseMsg';
import { Toast } from 'vant';
import { removeToken } from '@/utils/auth';
export default {
  name: 'index',
  data() {
    return {
      unfinishedDataList: [], //待办列表
      nowTime: '', //系统当前时间
      jiagecaiji: '',
      daitianbao: '',
      jiageshenhe: '',
      jiageFill: '',

      baseUrl: '',
      tongzhigonggao: '',
      xiaoxitixing: '',
      yujingchaxun: '',
      leadCheck: '',
      addressBook: '', //通讯录
      btnFlag: false, //置顶图标
      count: [],
      //已完成事项
      finishData: [],
      loginStatus: true,
      // userPermissions: [true, true, true, true, true, true, true, true, true, true, true, true],//权限问题
      isBarNav: false,
      userMenu: [], //用户权限
      //待办事项
      dbcount: 0, //代办事项数量
      dtcount: 0, //待填报数量
      dscount: 0, //待审事项数量
      dtbcount: 0,
      caseInfoList: [],
      isLoading: false,
      wdcount: 0, //消息提醒
      tzcount: 0, //通知公告
      dbCountrycount: 0,
      jiageSearch: '', //价格查询
      jiagePublish: '', //价格发布
      marketInspection: '', //市场巡查
      unfinishedCount: '', //代办数量
      provincialWarningManage: '', //省级预警信息处理
      cityReport: '',
      unCityDonCount: 0,

      levelNum: 1, //是否显示省级预警处理这个功能levelNum
      menuList: [],
      warnCount: 0
    };
  },
  created() {
    this.baseUrl = config.baseURL;
    this.vueConfigPublicPath = config.vueConfigPublicPath;
    this.jiagecaiji = '/jiagecaijiNew/jiagecaijiNew'; //价格采集
    this.qxtbcaiji = this.vueConfigPublicPath + '/qxtbcaiji/qxtbcaiji';
    this.daitianbao = this.vueConfigPublicPath + '/agentFill/agentFill'; //市级代填报
    this.jiageshenhe = '/jiageshenheListNew/jiageshenheListNew'; //价格审核
    this.addressBook = this.vueConfigPublicPath + '/addressBook/addressBook'; //通讯录
    this.xiaoxitixing = this.vueConfigPublicPath + '/xiaoxitixing'; //消息提醒
    this.yujingchaxun = this.vueConfigPublicPath + '/warningQuery'; //预警查询
    this.tongzhigonggao = this.vueConfigPublicPath + '/tongzhigonggao'; //通知公告
    this.provincialWarningManage = this.vueConfigPublicPath + '/provincialWarningManage'; //预警处理
    this.marketInspection = this.vueConfigPublicPath + '/marketInspection'; //市场巡查
    this.perInfoManage = this.vueConfigPublicPath + '/perInfoManage';
    this.jiageFill = this.vueConfigPublicPath + '/shengjiAgenFill/shengjiAgenFill';
    this.jiageSearch = ''; //价格查询
    this.cityReport = this.vueConfigPublicPath + '/cityReport';
    // this.jiagePublish=this.vueConfigPublicPath + "/publishList";//价格发布
    this.init();
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop);
  },
  methods: {
    handTranUrl(url) {
      let toUrl = url.indexOf("http") > -1 ? url.slice(1) : (this.vueConfigPublicPath + url)
      return toUrl
    },
    init() {
      loading(true);
      this.checkLogin();
      if (this.loginStatus) {
        this.getCaseCountNew();
      }
    },
    //价格采集和价格审核数量New
    getCaseCountNew() {
      getCaseCountNew({}).then((res) => {
        this.dbcount = res[0].unDonCount; //待采集
        this.dscount = res[1].unDonCount; //待审核数量
        this.tzcount = res[2].readerCount; //通知公告
        this.dbCountrycount = res[4] ? res[4].unDonCountCountry : 0; //通知公告
        this.levelNum = res[1].levelNum;
        if (res[1].levelNum == '2') {
          this.unCityDonCount = res[3].unCityDonCount; //市级待审核
        }
        if (res[0].levelNum == 1) {
          this.dbcount = res[4].unDonCountCountry;
        }
        if (res[0].levelNum == 1) {
          this.warnCount = res[5].unDonWarnCount;
        }
        this.dtbcount = res[3].unRFillCount; //省级代填报
        loading(false);
      });
    },

    handPush(val) {
      if(val == 'jiageshenhe') {
        this.$router.push({
          path: this.jiageshenhe
        })
      }else {
        if(this.menuList.map(item => item.path).indexOf(this.jiagecaiji) > -1) {
          this.$router.push({
            path: this.jiagecaiji
          })
        }
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.init();
      }, 300);
    },
    checkLogin() {
      const loginType = this.$store.state.login.loginType;
      if (loginType == 1) {
        // 小程序登录
        loading(true);
        getUserInfoAjax2().then((res) => {
          if (res.code == 200) {
            if (!res.data.openId) {
              removeToken();
              this.$router.push({ path: '/login' });
            }
          }
          loading(false);
        });
      }
      this.menuList = [];
      this.$store.getters.routes.forEach((i) => {
        if (i.path == 'APP') {
          i.children.forEach(c=> {
            this.menuList.push(c)
          })
        }
      });
    },
    //置顶图标
    backTop() {
      const that = this;
      const timer = setInterval(() => {
        const ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 为了计算距离顶部的高度，当高度大于130显示回顶部图标，小于130则隐藏
    scrollToTop() {
      const that = this;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
      that.btnFlag = that.scrollTop > 130;
    },
    clickBtu() {
      Toast('此功能暂未开放！');
      return;
    },
    navSwitch() {
      this.isBarNav = !this.isBarNav;
    },
    // 点击投诉与建议
    handleGoComplaint() {
      this.$router.push('/complaintSuggestion');
    }
  },
  watch: {
    $route: {
      handler(route) {
        const that = this;
        if (route.name == 'index') {
          that.init();
        }
      },
      deep: true
    }
  }
};
